/**
 * Espelha o request de POST Oportunidade/idOportunidade/{idOportunidade}/ocorrencia da API CRM: anotação do
 * usuário no histórico da oportunidade (tipo 5). Tipo, origem e usuário são postos pelo servidor.
 */
export class CriarOportunidadeOcorrenciaRequest {
  /** Texto do usuário, até 1000 caracteres. */
  descricao: string;
  /** Data do fato, sem futuro; ausente = agora. */
  dataOcorrencia: Date | null = null;
}
